for (const el of document.querySelectorAll('.vp-block-list-children')) {
    const selects = el.querySelectorAll('select')
    for (const select of selects) {
        select.addEventListener('change', () => {
            applyFilters(selects)
        })
    }
}

function applyFilters(list) {
    const location =
        document.location.protocol +
        '//' +
        document.location.host +
        document.location.pathname.replace(/\page\/\d+\//, '')
    const url = new URL(location)
    url.search = ''
    console.log(document.location)
    console.log(url.toString())

    list = [...list]
        .filter((el) => parseInt(el.value, 10) > 0)
        .map((el) => ({
            taxonomy: el.getAttribute('name'),
            value: el.value,
        }))

    if (list.length) {
        for (const el of list) {
            url.searchParams.set(el.taxonomy, el.value)
        }
    }

    url.hash = 'list'
    document.location.href = url.toString()
}
